import { Injectable, inject } from '@angular/core';

import { CompetitionBatchRequest } from '@cds/query-objects';
import { CompetitionStatistics } from '@cds/statistics/competition';
import { FixtureStatistics } from '@cds/statistics/fixture';
import { BaseCdsApi, BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StatisticsApi {
    private cdsApi: BaseCdsApi;

    constructor() {
        const cdsApiServiceFactory = inject<BaseCdsApiFactory>(CDS_API_FACTORY);

        this.cdsApi = cdsApiServiceFactory({ endpoint: '/statistics' });
    }

    getCompetitionStatistics(
        competitionId: number,
        sportId: number,
        stageId?: number,
        groupId?: number,
    ): Observable<CompetitionStatistics | undefined> {
        return this.cdsApi.get<CompetitionStatistics>('/competition', {
            competitionId,
            sportId,
            stageId,
            groupId,
        });
    }

    getCompetitionStatisticsBatch(competitionIds: string, sportId: number): Observable<CompetitionStatistics[] | undefined> {
        return this.cdsApi.get<CompetitionStatistics[]>('/competition-batch', {
            competitionIds,
            sportId,
        });
    }

    getCompetitionStatisticsBatchV2(competitionBatchRequest: CompetitionBatchRequest): Observable<CompetitionStatistics[] | undefined> {
        return this.cdsApi.post<CompetitionStatistics[]>('/competition-batch/v2', competitionBatchRequest);
    }

    getFixtureStatistics(fixtureId: string, sportId: number): Promise<FixtureStatistics | undefined> {
        return firstValueFrom(
            this.cdsApi.get<FixtureStatistics>('/fixture', {
                fixtureId,
                sportId,
            }),
        );
    }
}
